<template>
    <div class="container auction-live" v-if="auction && (auction.state === CONSTANTS.AUCTION_STATE_STARTED)">
        <div class="row no-margin-rl">
            <div class="col-md-12 no-padding-rl">
                <div class="auction-live-top">
                    <div class="auction-live-header mg-sm-15">
                        <div class="bottom">
                            <div class="change-product"
                                 v-bind:class="{ d_right: (previousProduct == null), d_left: (nextProduct == null) }">
                                <button class="btn-change" v-if="previousProduct"
                                        @click="getDataBid(previousProduct.product_id); leaveChannel(auction.id, product.product_id);">
                                    <i class="fas fa-chevron-left icon-arrow mr-2"></i><span>前<span
                                    class="d-none d-md-inline-block">の商品</span>ヘ</span>
                                </button>
                                <button class="btn-change" v-if="nextProduct"
                                        @click="getDataBid(nextProduct.product_id); leaveChannel(auction.id, product.product_id);">
                                    <span>次<span class="d-none d-md-inline-block">の商品</span>ヘ</span><i
                                    class="fas fa-chevron-right icon-arrow ml-2"></i>
                                </button>
                            </div>
                            <div class="product-no">
                                <div class="b-info b-tag">
                                    <span class="tag tag-pink tag-live" v-if="product.is_streaming == 1"><img
                                        :src="'/img/home/icon-live.svg'" class="mr-1" alt="">LIVE</span>
                                </div>
                                <span class="product-text">
                                    Lot No.
                                    <span class="product-id">{{ product.order }}</span>
                                </span>
                            </div>
                            <div class="b-product-name">
                                <h3 class="d-flex align-items-center justify-content-center">{{ product.name }}</h3>
                            </div>
                            <div class="auction-info">
                                <div class="b-info" v-if="auction.is_prebid == 0">
                                    開催日時 :
                                    <span class="text">{{ formatDate(auction.start_time) }}
                                     ～ {{ formatDate(auction.end_time) }}
                                    </span>
                                    <span class="line-vertical">|</span>
                                </div>

                                <div class="b-info" v-else>
                                    事前入札日時 :
                                    <span class="text">{{
                                            formatDate(auction.prebid_start_time)
                                        }} ～ {{ formatDate(auction.prebid_end_time) }}
                                    </span>
                                    <span class="line-vertical">|</span>
                                </div>
                                <div class="b-favorite">
                                    <button :disabled="loading"
                                            @click="favorite(!empty(checkFavorite), product.product_id, member.id, auction.id)"
                                            class="btn-favorite">
                                        <i class="icon-start fas fa-star"
                                           :style="!empty(checkFavorite) ? 'color: #E52D51' : 'color: #D0CDC8'"></i>
                                    </button>
                                    <span class="count" v-if="countFavorite > 0">{{ countFavorite }} 人が登録</span>
                                    <span class="count" v-else>お気に入りに登録</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="auction-live-content">
                        <div class="left">
                            <div class="video-product">
                                <embed v-if="youtubeStream" style="width: 100%; height: 350px"
                                       :src=urlStream>
                                <video v-if="!youtubeStream" id="player" autoplay playsinline muted controls
                                       @canplay="updatePaused" @playing="updatePaused" @pause="updatePaused"></video>
                            </div>

                            <div class="gallery">
                                <div class="border-image" v-if="mainImg">
                                    <a class="grid-item gallery-item" :href="mainImg" data-lightbox="gallery">
                                        <img class="pd-15 w-100 mh-500 object-contain"
                                             :src="mainImg" alt="image-main"
                                             @error="handleImageError"
                                        >
                                    </a>
                                </div>
                                <div class="list-image mg-sm-15 mt-30">
                                    <div class="item-image" v-for="image in notMainImg">
                                        <div class="b-img img-show">
                                            <a class="gallery-item" :href="image" data-lightbox="gallery">
                                                <img @error="handleImageError" :src="image" alt="image-not-main" class="object-contain">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="info mg-sm-15">
                                <div class="mb-2 fs-19">
                                    商品説明
                                </div>
                                <div class="item-info">
                                    <div class="right">商品名</div>
                                    <div class="left">{{ product.name }}</div>
                                </div>
                                <div class="item-info" v-if="!parseInt(product.can_buy_now) && product.estimate_from && product.estimate_to">
                                    <div class="right">エスティメート</div>
                                    <div class="left">¥{{ formatPrice(product.estimate_from )}} <span class="ml-1 mr-1">~</span> {{ formatPrice(product.estimate_to) }}</div>
                                </div>
                                <div class="item-info">
                                    <div class="right">商品説明</div>
                                    <div class="left">{{ product.description }}</div>
                                </div>
                                <div class="item-info">
                                    <div class="right">略歴</div>
                                    <div class="left">{{ product.story }}</div>
                                </div>
                                <div class="item-info">
                                    <div class="right">サイズ</div>
                                    <div class="left">{{ product.size }}</div>
                                </div>
                                <div class="item-info">
                                    <div class="right">カテゴリー</div>
                                    <div class="left">
                                        <button>{{ product.category.name }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="current-price">
                                <div class="b-current-price">
                                    <div class="top">
                                        <div class="tag-finish" v-if="isFinish || isError">
                                            販売終了
                                        </div>
                                        <p class="title">現在価格</p>
                                        <div class="price">
                                            <span class="text">¥</span>
                                            <span class="number">{{ formatPrice(amountBid) }}</span>
                                        </div>
                                        <div class="tax-fee">
                                            <span class="text">消費税手数料込</span>
                                            <span class="number">¥ {{ handlePriceTaxAndServiceFee(amountBid) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p class="noti-finish win" v-if="isWinBid && isFinish && !isBidFail">
                                <img src="/img/frontend/award-bid-won.svg" alt="award-bid-won">
                                あなたが落札者です。
                            </p>
                            <p class="noti-finish lose" v-if="!isWinBid && isFinish && !isBidFail">
                                <img src="/img/frontend/lose-bid-sad.svg" alt="lose-bid-sad">
                                他のお客様が落札しました。
                            </p>
                            <p class="next-price" v-if="!isFinish && product.state != 4">次の入札価格 <span>¥{{
                                    formatPrice(amountBid + priceStep)
                                }}</span>
                            </p>
                            <div class="block-noti" v-if="isChangePriceText">
                                <div class="text-updated"><i class="icon fas fa-exclamation-circle"></i> <span>現在の入札価格が更新されています。</span>
                                </div>
                            </div>
                            <div class="block-bottom-live-bid">
                                <button class="btn-send-price btn-large btn-can-bid" @click.prevent="handleSaveBidLive"
                                        v-if="product.is_streaming == 1 && isButtonDisabled && isPause && !isFinish && !isError"
                                        v-bind:class="{ 'btn-disabled': (product.is_streaming == 1 && (!isButtonDisabled || !isPause)) || isError }"
                                >入札する
                                </button>

                                <button class="btn-send-price btn-large btn-can-not-bid"
                                        v-if="product.is_streaming == 0 || !isButtonDisabled || !isPause || isFinish || isError"
                                        v-bind:class="{ 'btn-disabled': (product.is_streaming == 1 && (!isButtonDisabled || !isPause)) || isFinish || isError || (product.is_streaming == 0)}"
                                >入札する
                                </button>
                                <p class="confirm-bid">
                                    <input type="checkbox" id="confirm-cbk"
                                           v-model="isConfirmModalOpen"
                                    >
                                    <label for="confirm-cbk">※入札確認を表示しない</label>
                                    <i class="icon fas fa-question-circle show-tooltip" style="cursor: pointer">
                                    </i>
                                </p>

                                <div class="confirm-bid-tool-tip">
                                    「入札する」ボタンを押した際に、確認画面が出現しなくなります。
                                    <br>
                                    ※「入札確認を表示しない」による誤入札にはくれぐれもご注意ください。
                                </div>
                            </div>
                            <HistoryBidComponent :histories="histories" :member="member" :duplicateBidAmountMax="duplicateBidAmountMax"/>
                            <div class="note-page-bid mt-4 mg-sm-15">
                                <div class="mb-2">メモ</div>
                                <div class="block-note note-product" :class="`note-${product.product_id}`">
                                    <textarea class="text-note" maxlength="2000" v-model="productNote"
                                              rows="5">
                                        {{ productNote }}
                                    </textarea>
                                    <div class="noti text-success fs-13 mt-1"></div>
                                    <div class="noti text-danger fs-13 mt-1"></div>
                                    <div class="text-right">
                                        <button class="btn-submit-note" v-bind:data-id="product.product_id"
                                                @click="submitProductNote">保存
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="auction-live-bottom mg-sm-15">
                        <div class="fs-22 font-weight-bold text-center mb-1">
                            出品物一覧
                        </div>
                        <div class="mb-3 bottom-title-image"></div>
                        <div class="exhibition-list">
                            <div class="list">
                                <div class="item-list" v-for="(image, index) in listImgAuction"
                                     @click="getDataBid(productAuction[index].product_id); leaveChannel(auction.id, product.product_id); backToTop();">
                                    <div class="b-img">
                                        <img @error="handleImageError" :src="image" alt="">
                                    </div>
                                    <div>
                                        <div class="no-product">【Lot No.{{
                                                productAuction[index].order
                                            }}】
                                        </div>
                                        <div class="name">{{ productAuction[index].name }}</div>
                                    </div>
                                    <div v-if="productAuction[index].is_streaming == 1" class="tag"><img
                                        :src="'/img/home/camera.svg'" class="mr-2" alt="" style="width: 18px;">LIVE中
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bid-mobile">
                        <div class="current-price">
                            <div class="b-current-price">
                                <div class="top">
                                    <div class="tag-finish" v-if="isFinish || isError">
                                        販売終了
                                    </div>
                                    <p class="title">現在価格</p>
                                    <div class="price">
                                        <span class="text">¥</span>
                                        <span class="number">{{ formatPrice(amountBid) }}</span>
                                    </div>
                                    <div class="tax-fee">
                                        <span class="text">消費税手数料込</span>
                                        <span class="number">¥ {{ handlePriceTaxAndServiceFee(amountBid) }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="block-noti" v-if="isChangePriceText">
                                <div class="text-updated"><i class="icon fas fa-exclamation-circle"></i> <span>現在の入札価格が更新されています。</span>
                                </div>
                            </div>
                            <p class="noti-finish win" v-if="isWinBid && isFinish && !isBidFail">
                                <img src="/img/frontend/award-bid-won.svg" alt="award-bid-won">
                                あなたが落札者です。
                            </p>
                            <p class="noti-finish lose" v-if="!isWinBid && isFinish && !isBidFail">
                                <img src="/img/frontend/lose-bid-sad.svg" alt="lose-bid-sad">
                                他のお客様が落札しました。
                            </p>
                            <p class="next-price" v-if="!isFinish && product.state != 4">次の入札価格 <span>¥{{
                                    formatPrice(amountBid + priceStep)
                                }}</span>
                            </p>
                        </div>

                        <button class="btn-send-price btn-large" @click.prevent="handleSaveBidLive"
                                v-if="product.is_streaming == 1 && isButtonDisabled && isPause && !isFinish && !isError"
                                v-bind:class="{ 'btn-disabled': (product.is_streaming == 1 && (!isButtonDisabled || !isPause)) || isError }"
                        >入札する
                        </button>

                        <button class="btn-send-price btn-large btn-disabled"
                                v-if="product.is_streaming == 0 || !isButtonDisabled || !isPause || isFinish || isError"
                                v-bind:class="{ 'btn-disabled': (product.is_streaming == 1 && (!isButtonDisabled || !isPause)) || isFinish || isError || (product.is_streaming == 0)}"
                        >入札する
                        </button>
                        <p class="confirm-bid">
                            <input type="checkbox" id="confirm-cbk"
                                   v-model="isConfirmModalOpen"
                            >
                            <label for="confirm-cbk">※入札確認を表示しない</label>
                            <i class="icon fas fa-question-circle" data-toggle="tooltip" data-placement="top"
                               style="cursor: pointer"
                               title="「入札する」ボタンを押した際に、確認画面が出現しなくなります。
                            ※「入札確認を表示しない」による誤入札にはくれぐれもご注意ください。"></i>
                        </p>
                    </div>
                    <div class="show-img d-none">
                        <div class="b-show-img">
                            <div class="top"><i class="fas fa-times icon-close"></i></div>
                            <div class="bottom">
                                <div class="icon"><i class="fas fa-chevron-left"></i></div>
                                <div class="show"><img :src="'/img/backend/image-default.png'" alt=""></div>
                                <div class="icon"><i class="fas fa-chevron-right"></i></div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-won-bid">
                        <div class="modal-overlay" v-if="isModalOpen">
                            <div class="modal-1">
                                <span class="close" @click="closeModal">&times;</span>
                                <div class="content">
                                    <div class="b-content">
                                        <div class="b-img">
                                            <img src="/img/frontend/harmer_won_bid.svg" alt="harmer_won_bid">
                                            <img src="/img/frontend/harmer_won_bid.svg" alt="harmer_won_bid">
                                            <img src="/img/frontend/harmer_won_bid.svg" alt="harmer_won_bid">
                                        </div>
                                        <p class="title" v-if="isWinBid && isFinish">
                                            あなたが Lot No. {{ idProductFinish }} の落札者です。<br>
                                        </p>
                                        <p class="title" v-if="!isWinBid && isFinish">
                                            Lot No. {{ idProductFinish }} の入札時間が終了しました。
                                        </p>
                                        <div v-if="isWinBid && isFinish">
                                            <p class="price">
                                                入札価格：
                                                <span class="number">¥{{ formatPrice(priceBidFinish) }}</span>
                                            </p>
                                            <div class="text-small">
                                                手数料含む：
                                                <span>
                                                (¥{{
                                                        handlePriceTaxAndServiceFee(priceBidFinish)
                                                    }})
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer border-top-0 justify-content-center">
                                        <button type="button"
                                                class="btn btn-close-modal"
                                                data-dismiss="modal" @click="closeModal()">閉じる
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Modal confirm bid -->
                    <div class="modal fade" id="priceBidProductModal" tabindex="-1"
                         aria-labelledby="exampleModalLabel"
                         aria-hidden="true" data-backdrop="static">
                        <div class="modal-dialog transform-modal">
                            <div class="modal-content">
                                <div class="modal-header border-bottom-0">
                                    <h3 class="modal-title font-weight-bold text-right"
                                        style="width: 59%">
                                        入札確認</h3>
                                    <button type="button" class="close" data-dismiss="modal"
                                            aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="text-center mt-4">
                                    <span>入札価格 :</span>
                                    <span class="color-red"
                                          style="font-weight: 700;color: #E52D51 !important;">¥{{
                                            formatPrice(amountBidModal + priceStep)
                                        }}</span>
                                </div>
                                <div class="text-center mt-1">
                                    <span>手数料含む</span>
                                    <span>(¥{{
                                            handlePriceTaxAndServiceFee(amountBidModal + priceStep)
                                        }})</span>
                                </div>
                                <div class="text-center mt-1 mb-4">
                                    <span>この金額で入札する</span>
                                </div>
                                <div class="modal-footer border-top-0 justify-content-center">
                                    <button
                                        @click="handleUpBidPrice('', auction.id, product.product_id, product.id, priceStep)"
                                        class="btn btn-submit-modal-bid-price-product">はい
                                    </button>
                                    <button type="button"
                                            class="btn btn-cancel-modal-bid-price-product"
                                            data-dismiss="modal">いいえ
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container auction-live" v-else-if="isEndBid">
        <div class="row">
            <div class="col-md-12 empty-live">
                <div class="b-text">
                    <div class="title">開催終了</div>
                    <div class="mb-3 bottom-title-image"></div>
                    <div class="text">
                        本日のLIVE配信オークションは終了致しました。<br>
                        落札者にお支払い内容を連絡させていただきます。
                    </div>
                    <div class="btn-back d-flex justify-content-center">
                        <a class="back-home" type="button" href="/home">トップページに戻る</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.btn-back {
    .back-home {
        padding: 20px 75px;
        height: 55px;
        font-weight: 400;
        line-height: 23px;
        display: flex;
        align-items: center;
    }
}
</style>
<script>
import CONSTANTS from "../constants";
import HistoryBidComponent from './HistoryBidComponent';
import SimpleLightbox from 'simplelightbox';
import 'simplelightbox/dist/simple-lightbox.min.css';
import {COMMON} from "../../common";

export default {
    computed: {
        CONSTANTS() {
            return CONSTANTS
        }
    },
    mounted() {

    },
    async created() {
        await this.getDataBid();
        await this.getAuctionProduct();

        await this.playWowza();

        Echo.channel('auction.check_error_product' + this.auction.id + '.' + this.product.product_id)
            .listen('.auction.check_error_product', (e) => {
                this.getAuctionProduct();
                this.closeBidProductModal();
            });

        Echo.channel('auction.live')
            .listen('.auction.live', (e) => {
                this.getDataBid();
            });

        Echo.channel('auction.' + this.auction.id)
            .listen('.auction.end', (e) => {
                let btnLive = document.getElementsByClassName("btn-live");

                btnLive[0].classList.remove('d-flex');
                btnLive[0].classList.add('d-none');
                this.auction.state = e.auction.state;
                this.auction.is_streaming = e.auction.is_streaming;
                this.isChangePriceText = false;
                this.isModalOpen = false;
                this.isFinish = false;
                this.isWinBid = false;
                this.isEndBid = true;
            });

        Echo.channel('auction.' + this.auction.id)
            .listen('.auction.trackProductLive', (e) => {
                if (this.product.product_id != e.auctionProduct.product_id) {
                    this.leaveChannel(this.auction.id, this.product.product_id);
                    this.getDataBid(e.auctionProduct.product_id);
                }
            });

        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
            .listen('.bid.start', (e) => {
                this.product.is_streaming = e.auctionProduct.is_streaming;
                this.product.state = e.auctionProduct.state;
                this.product.member_id = e.auctionProduct.member_id;
                this.isButtonDisabled = true;
                this.isPause = true;
                this.isBidFail = e.auctionProduct.member_id == null;
                this.closeBidProductModal();
                if (this.product.state == 4) {
                    setTimeout(() => {
                        this.isModalOpen = true;
                    },1000);
                    this.priceBidFinish = this.amountBid;
                    this.idProductFinish = e.auctionProduct.order;
                    this.isWinBid = this.product.member_id == this.member.id;
                    this.isFinish = true;
                    this.isChangePriceText = false;
                } else if (this.product.state == CONSTANTS.AUCTION_STATE_END && this.product.is_streaming == 0 && e.auctionProduct.is_finished == 1) {
                    setTimeout(() => {
                        this.isModalOpen = true;
                    },1000);
                    this.idProductFinish = e.auctionProduct.order;
                    this.isFinish = true;
                    this.isChangePriceText = false;
                }
            });

        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
            .listen('.bid.sent', (e) => {
                if (this.amountBid || this.amountBid == 0) {
                    this.amountBid = e.bid.amount;
                }
                this.duplicateBidAmountMax = e.duplicateBidAmountMax ?? 0;
                this.histories.unshift(e.bid);
                this.isChangePriceText = e.member.id !== this.member.id;
                this.priceStep = e.priceStep;
            });

        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
            .listen('.bid.pause', (e) => {
                this.isButtonDisabled = !(e.product.is_pause);
                this.isPause = !(e.product.is_pause);
            });

        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
            .listen('.bid.remove', (e) => {
                let id = e.product.product_id;
                Echo.leave('bid.' + this.auction.id + '.' + this.product.product_id)
                this.getDataBid(id);
            });

        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
            .listen('.bid.fail', (e) => {
                this.product.state = e.product.state;
            });

        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
            .listen('.bid.reset', (e) => {
                if (this.product.product_id == e.product.product_id) {
                    this.isChangePriceText = false;
                    this.isFinish = false;
                    this.isWinBid = false;
                    let id = e.product.product_id;
                    this.getDataBidNew(id);
                    this.histories = [];
                    this.isModalOpen = false;
                }
            });

        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
            .listen('.bid.startPrice', (e) => {
                this.amountBid = e.amountBidStart;
            });

        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
            .listen('.bid.sentLiveHall', (e) => {
                if (e.bid) {
                    this.isChangePriceText = true;
                    if (this.amountBid || this.amountBid == 0) {
                        this.amountBid = e.bid.amount;
                    }
                    this.histories.unshift(e.bid);
                    this.priceStep = e.priceStep;
                }

                this.duplicateBidAmountMax = e.duplicateBidAmountMax ?? 0;
            });

        this.initSimpleLightbox();
    },
    data: function () {
        return {
            histories: [],
            auction: null,
            productAuction: null,
            product: null,
            previousProduct: null,
            nextProduct: null,
            productsSimilar: null,
            notMainImg: null,
            mainImg: null,
            listImgAuction: null,
            amountBid: null,
            amountMyBid: null,
            isButtonDisabled: false,
            member: null,
            checkFavorite: null,
            countFavorite: 0,
            isPause: false,
            isModalOpen: false,
            lightbox: null,
            youtubeStream: false,
            urlStream: null,
            priceBidFinish: 0,
            idProductFinish: 0,
            loading: false,
            serviceFee: 0,
            tax: 0,
            priceStep: null,
            isConfirmModalOpen: false,
            isChangePriceText: false,
            isWinBid: false,
            isFinish: false,
            productNote: null,
            isError: false,
            isEndBid: false,
            isBidFail: false,
            amountBidModal: null,
            duplicateBidAmountMax: 0,
        }
    },
    methods: {
        async playWowza() {
            if (!this.youtubeStream) {
                const player = new WowzaRtc.WowzaWebRtcPlayer('player');
                player.start(
                    process.env.MIX_WOWZA_WSS,
                    process.env.MIX_WOWZA_APP_NAME,
                    process.env.MIX_WOWZA_STREAM_NAME
                );
            }
        },

        updatePaused(event) {
            if (event.type === "pause") {
                this.playWowza();
            }
        },

        async getDataBid(id = null) {
            await axios.post(id ? `/member/bid/get-data-live-bid?id=${id}` : '/member/bid/get-data-live-bid')
                .then(response => {
                    if (response.data.auction.state !== CONSTANTS.AUCTION_STATE_STARTED || response.data.auction.is_streaming !== '1') {
                        if (this.isEndBid !== true) {
                            window.location.href = '/home';
                        }
                    }
                    this.auction = response.data.auction;
                    this.product = response.data.product;
                    this.previousProduct = response.data.previousProduct;
                    this.nextProduct = response.data.nextProduct;
                    this.notMainImg = response.data.notMainImg;
                    this.mainImg = response.data.mainImg;
                    this.listImgAuction = response.data.listImgAuction;
                    this.productAuction = response.data.productAuction;
                    this.productsSimilar = response.data.productsSimilar;
                    this.amountMyBid = response.data.amountMyBid
                    this.amountBid = response.data.product.amount;
                    this.histories = response.data.histories;
                    this.member = response.data.member;
                    this.checkFavorite = response.data.checkFavorite;
                    this.countFavorite = response.data.countFavorite;
                    this.isButtonDisabled = response.data.product.is_streaming == 1 && response.data.product.is_pause == 0;
                    this.isPause = response.data.product.is_streaming == 1 && response.data.product.is_pause == 0;
                    this.serviceFee = response.data.taxConfig.service_fee;
                    this.tax = response.data.taxConfig.tax;
                    this.priceStep = response.data.priceStep;
                    this.productNote = response.data.productNote;
                    this.isModalOpen = false;
                    this.isError = response.data.product.is_error == 1 ? true : false;
                    this.duplicateBidAmountMax = response.data.duplicateBidAmountMax;
                    if (response.data.auction.stream_url != null && response.data.auction.stream_url != '') {
                        this.youtubeStream = true;
                        this.urlStream = response.data.auction.stream_url + '?autoplay=1&mute=1';
                    } else {
                        this.youtubeStream = false;
                        this.urlStream = null;
                    }

                    if (id) {
                        Echo.leave();

                        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                            .listen('.bid.start', (e) => {
                                this.product.is_streaming = e.auctionProduct.is_streaming;
                                this.product.state = e.auctionProduct.state;
                                this.product.member_id = e.auctionProduct.member_id;
                                this.isButtonDisabled = true;
                                this.isPause = true;
                                this.isBidFail = e.auctionProduct.member_id == null;
                                this.closeBidProductModal();
                                if (this.product.state == 4) {
                                    setTimeout(() => {
                                        this.isModalOpen = true;
                                    },1000);
                                    this.priceBidFinish = this.amountBid;
                                    this.idProductFinish = e.auctionProduct.order;
                                    this.isWinBid = this.product.member_id == this.member.id;
                                    this.isFinish = true;
                                    this.isChangePriceText = false;
                                } else if (this.product.state == CONSTANTS.AUCTION_STATE_END && this.product.is_streaming == 0 && e.auctionProduct.is_finished == 1) {
                                    setTimeout(() => {
                                        this.isModalOpen = true;
                                    },1000);
                                    this.idProductFinish = e.auctionProduct.order;
                                    this.isFinish = true;
                                    this.isChangePriceText = false;
                                }
                            });

                        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                            .listen('.bid.sent', (e) => {
                                if (this.amountBid || this.amountBid == 0) {
                                    this.amountBid = e.bid.amount;
                                }
                                this.histories.unshift(e.bid);
                                this.isChangePriceText = e.member.id !== this.member.id;
                                this.priceStep = e.priceStep;
                                this.duplicateBidAmountMax = e.duplicateBidAmountMax ?? 0;
                            });

                        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                            .listen('.bid.remove', (e) => {
                                let id = e.product.product_id
                                Echo.leave('bid.' + this.auction.id + '.' + this.product.product_id)
                                this.getDataBid(id);
                            });

                        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                            .listen('.bid.pause', (e) => {
                                this.isButtonDisabled = !(e.product.is_pause);
                                this.isPause = !(e.product.is_pause);
                            });

                        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                            .listen('.bid.fail', (e) => {
                                this.product.state = e.product.state;
                            });

                        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                            .listen('.bid.reset', (e) => {
                                if (this.product.product_id == e.product.product_id) {
                                    let id = e.product.product_id;
                                    this.getDataBidNew(id);
                                    this.isChangePriceText = false;
                                    this.isFinish = false;
                                    this.isWinBid = false;
                                    this.isModalOpen = false;
                                    this.histories = [];
                                }
                            });

                        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                            .listen('.bid.startPrice', (e) => {
                                this.amountBid = e.amountBidStart;
                            });

                        Echo.channel('auction.check_error_product' + this.auction.id + '.' + this.product.product_id)
                            .listen('.auction.check_error_product', (e) => {
                                this.getAuctionProduct();
                                this.closeBidProductModal();
                            });

                        Echo.channel('bid.' + this.auction.id + '.' + this.product.product_id)
                            .listen('.bid.sentLiveHall', (e) => {
                                if (e.bid) {
                                    this.isChangePriceText = true;
                                    if (this.amountBid || this.amountBid == 0) {
                                        this.amountBid = e.bid.amount;
                                    }
                                    this.histories.unshift(e.bid);
                                    this.priceStep = e.priceStep;
                                }
                                this.duplicateBidAmountMax = e.duplicateBidAmountMax;
                            });

                        this.destroySimpleLightbox();

                        this.initSimpleLightbox();
                    }
                })
                .catch(error => {})
        },

        async getDataBidNew(id) {
            await axios.post(`/member/bid/get-data-live-bid?id=${id}`)
                .then(response => {
                    if (response.data.auction.state !== CONSTANTS.AUCTION_STATE_STARTED || response.data.auction.is_streaming !== '1') {
                        window.location.href = '/home';
                    }
                    this.auction = response.data.auction;
                    this.product = response.data.product;
                    this.previousProduct = response.data.previousProduct;
                    this.nextProduct = response.data.nextProduct;
                    this.notMainImg = response.data.notMainImg;
                    this.mainImg = response.data.mainImg;
                    this.listImgAuction = response.data.listImgAuction;
                    this.productAuction = response.data.productAuction;
                    this.productsSimilar = response.data.productsSimilar;
                    this.amountMyBid = response.data.amountMyBid
                    this.amountBid = response.data.product.amount;
                    this.histories = response.data.histories;
                    this.member = response.data.member;
                    this.checkFavorite = response.data.checkFavorite;
                    this.countFavorite = response.data.countFavorite;
                    this.isButtonDisabled = response.data.product.is_streaming == 1 && response.data.product.is_pause == 0;
                    this.isPause = response.data.product.is_streaming == 1 && response.data.product.is_pause == 0;
                    this.serviceFee = response.data.taxConfig.service_fee;
                    this.tax = response.data.taxConfig.tax;
                    this.priceStep = response.data.priceStep;
                    this.productNote = response.data.productNote;
                    this.isModalOpen = false;
                    this.isError = response.data.product.is_error == 1 ? true : false;
                    this.duplicateBidAmountMax = response.data.duplicateBidAmountMax ?? 0;

                    if (response.data.auction.stream_url != null && response.data.auction.stream_url != '') {
                        this.youtubeStream = true;
                        this.urlStream = response.data.auction.stream_url + '?autoplay=1&mute=1';
                    } else {
                        this.youtubeStream = false;
                        this.urlStream = null;
                    }

                    this.destroySimpleLightbox();

                    this.initSimpleLightbox();
                })
                .catch(error => {})
        },

        formatDate(dateString) {
            if (!dateString) {
                return '';
            }

            const normalizedDateString = dateString.replace(' ', 'T');
            const date = new Date(normalizedDateString);

            if (isNaN(date)) {
                return '';
            }

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}/${month}/${day} ${hours}:${minutes}`;
        },

        handleImageError(event) {
            event.target.src = '/img/backend/image-default.png';
            event.target.parentNode.href = '/img/backend/image-default.png';
        },

        formatPrice(price) {
            return COMMON.handleFormatPrice(price);
        },

        handlePriceTaxAndServiceFee(pricePresent) {
            let price = COMMON.handlePriceTaxAndServiceFee(parseFloat(pricePresent), this.serviceFee, this.tax);
            return this.formatPrice(price);
        },

        async handleUpBidPrice(type = null, auction, product, auctionProduct, priceStep = null) {
            this.isButtonDisabled = false;
            if (this.isError) {
                this.closeBidProductModal();
                return false;
            }
            if (this.isModalOpen == true) {
                this.isModalOpen = false;
            }
            if (!this.isConfirmModalOpen && this.amountBidModal < this.amountBid) {
                $('.text-updated').text('現在価格より大きい価格を入力してください。');
                this.closeBidProductModal();
                this.disableAuctionButton();
                return false;
            }
            await axios({
                method: 'post',
                url: `/bid/${auction}/${product}/${auctionProduct}/update-price-bid`,
                data: {
                    type: type,
                    priceStep: COMMON.extractAndParseNumber(priceStep),
                    amountBidPrice: !this.isConfirmModalOpen ? COMMON.extractAndParseNumber(this.amountBidModal + priceStep) : COMMON.extractAndParseNumber(this.amountBid + priceStep),
                }
            })
                .then(response => {
                    if (response.data.amountMyBid != null) {
                        if (response.data.amountMyBid !== 'endLive') {
                            this.amountMyBid = response.data.amountMyBid.amount;
                        }
                        this.closeBidProductModal();
                    }
                    this.disableAuctionButton();
                })
                .catch((error) => {
                    if (error.response.status == 422) {
                        $('.text-updated').text('入札額は数値形式で入力してください。');
                        this.isChangePriceText = true;
                    }
                    this.closeBidProductModal();
                    this.disableAuctionButton();
                });
        },

        handlePriceRange(amountBid) {
            let priceIncreaseMin = null;
            let priceIncreaseMax = null;

            if (amountBid >= 0 && amountBid <= 5000) {
                priceIncreaseMin = 500;
                priceIncreaseMax = 1000;
            } else if (amountBid > 5000 && amountBid <= 100000) {
                priceIncreaseMin = 1000;
                priceIncreaseMax = 10000;
            } else if (amountBid > 100000 && amountBid <= 500000) {
                priceIncreaseMin = 5000;
                priceIncreaseMax = 50000;
            } else if (amountBid > 500000 && amountBid <= 5000000) {
                priceIncreaseMin = 10000;
                priceIncreaseMax = 100000;
            } else if (amountBid > 5000000) {
                priceIncreaseMin = 50000;
                priceIncreaseMax = 500000;
            }

            return {
                priceIncreaseMin: priceIncreaseMin,
                priceIncreaseMax: priceIncreaseMax
            }
        },

        disableAuctionButton() {
            this.isButtonDisabled = false;
            const delay = 2000;

            setTimeout(() => {
                this.isButtonDisabled = true;
            }, delay);
        },

        leaveChannel(auctionId, productId) {
            this.isFinish = false;
            this.isWinBid = false;
            this.isChangePriceText = false;
            this.isModalOpen = false;
            Echo.leave('bid.' + auctionId + '.' + productId);
        },

        empty(variable) {
            return !variable;
        },

        async favorite(active, productId, memberId, auctionId) {
            this.loading = true;
            try {
                if (active) {
                    await this.removeFavorite(productId, memberId);
                } else {
                    await this.addFavorite(productId, memberId, auctionId);
                }
            } finally {
                this.loading = false;  // Set loading to false when function ends
            }
        },

        async removeFavorite(productId, memberId) {
            await axios({
                method: 'post',
                url: `/member/bid/removeFavorite`,
                data: {
                    product_id: productId,
                    member_id: memberId,
                },
            })
                .then(response => {
                    if (response.status === 200) {
                        this.checkFavorite = false;
                        this.countFavorite = response.data.result;
                    }
                })
                .catch(error => {
                    this.checkFavorite = true;
                });
        },

        async addFavorite(productId, memberId, auctionId) {
            await axios({
                method: 'post',
                url: `/member/bid/addFavorite`,
                data: {
                    product_id: productId,
                    member_id: memberId,
                    auction_id: auctionId,
                },
            })
                .then(response => {
                    if (response.status === 200) {
                        this.checkFavorite = true;
                        this.countFavorite = response.data.result;
                    }
                })
                .catch(error => {
                    this.checkFavorite = false;
                });
        },

        getLink(productSerial, type) {
            let url = '';

            switch (type) {
                case 1:
                    url = `https://search.rakuten.co.jp/search/mall/${productSerial}`
                    break;
                case 2:
                    url = `https://auctions.yahoo.co.jp/closedsearch/closedsearch?p=${productSerial}`
                    break;
                case 3:
                    url = `https://jp.mercari.com/search?keyword=${productSerial}`
                    break;
            }

            return url;
        },

        closeModal() {
            this.isModalOpen = false;
        },

        initSimpleLightbox() {
            this.$nextTick(() => {
                this.lightbox = new SimpleLightbox('.gallery a', {});
            });
        },

        async destroySimpleLightbox() {
            if (this.lightbox) {
                await this.lightbox.destroy();
            }
        },

        backToTop() {
            this.$nextTick(() => {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            });
        },
        openBidProductModal() {
            this.amountBidModal = this.amountBid;
            $('#priceBidProductModal').modal('show');
        },

        closeBidProductModal() {
            this.amountBidModal = null;
            $('#priceBidProductModal').modal('hide');
        },
        handleSaveBidLive() {
            if (!this.isError) {
                if (!this.isConfirmModalOpen) {
                    this.openBidProductModal();
                } else {
                    this.handleUpBidPrice('', this.auction.id, this.product.product_id, this.product.id, this.priceStep);
                }
            }
        },
        async submitProductNote() {
            let element = '.note-' + this.product.product_id;
            if (this.productNote.length > 255) {
                $(`${element} .noti`).empty();
                $(`${element} .text-danger`).append('メモを追加には、255桁以下の文字を入力してください。');

                setTimeout(function () {
                    $(`${element} .noti`).empty();
                }, 3000);
            } else {
                await axios({
                    method: 'post',
                    url: `/member/storeProductNote`,
                    data: {
                        note: this.productNote,
                        product_id: this.product.product_id,
                        type: 'NOTE_PAGE_CATALOGUE'
                    },
                })
                    .then(response => {
                        if (response.status === 200) {
                            $(`${element} .noti`).empty();
                            $(`${element} .text-success`).append('メモの保存が成功しました。');

                            setTimeout(function () {
                                $(`${element} .noti`).empty();
                            }, 3000);
                        }
                    })
                    .catch(error => {
                        $(`${element} .noti`).empty();
                        $(`${element} .text-danger`).append('メモの保存が失敗しました。');

                        setTimeout(function () {
                            $(`${element} .noti`).empty();
                        }, 3000);
                    });
            }

        },
        async getAuctionProduct() {
            await axios.post('/bid/get-data-auction-product', {
                auctionId: this.auction.id,
                productId: this.product.product_id,
            })
                .then(res => {
                    this.isError = !!res.data.auctionProduct.is_error;
                })
                .catch(error => {

                })
        },
    },
    components: {
        HistoryBidComponent
    }
}
</script>
